import Collection from '../../collection';
import Server from '../../model/refbooks/server';





export default Collection.extend( {
	endpoint: 'scripts/servers/list?apiVersion=2.0&limit=1000000',
	responseAt: 'items',
    model: Server
} );


// WEBPACK FOOTER //
// ./src/js/collection/refbooks/servers.js